import React from "react";

import {
  StyledFormControl,
  StyledInput,
  StyledLabel,
} from "../../../Styled-Components/styles";

import StripeDisclaimer from "./StripeDisclaimer";
import ErrorMessage from "./ErrorMessage";
import StripeInput from "./StripeInput";
import Submit from "./Submit";

const PaymentDetails = (props) => {
  return (
    <div
      style={{
        width: "60%",
        minWidth: "225px",
        margin: "3vh auto",
        display: props.payment >= 5 ? "flex" : "none",
        flexDirection: "column",
        justifyContent: "center",
        alignContent: "space-around",
      }}
    >
      {/* <StyledFormControl>
        <StyledLabel>Map display name</StyledLabel>

        <StyledInput
          width="100%"
          value={props.mapDetails.name}
          placeholder={"name"}
          onChange={(e) =>
            props.setMapDetails({ ...props.mapDetails, name: e.target.value })
          }
        />
      </StyledFormControl> */}

      <StripeInput
        clientSecret={props.clientSecret}
        setError={props.setError}
        stripe={props.stripe}
      />
      <div
        style={{
          display: props.clientSecret ? "none" : "block",
          fontSize: "16px",
        }}
      >
        Payment field loading. If this persists, please try a different browser.
      </div>
      <StripeDisclaimer />
      <div>{props.error && <ErrorMessage>{props.error}</ErrorMessage>}</div>
      <div>
        <Submit
          processing={props.processing}
          stripe={props.stripe}
          clientSecret={props.clientSecret}
        />
      </div>
    </div>
  );
};

export default PaymentDetails;
